import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const CONTRACTS_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('CONTRACTS');
export const CONTRACTS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	CONTRACTS_CRUD_ACTION_CONSTANTS
);
